<template>
  <div class="app flex-row align-items-center">
    <div class="container-fluid">
      <b-row class="justify-content-center login-box">
        <b-col md="6" lg="5" xl="4">
          <div class="text-center mb-15">
              <img class="mb-25 logo-login" :src="`/logo.svg`">
              <!-- <div class="font-400">Administration Dashboard</div> -->
          </div>
          <b-card-group>
            <b-card no-body class="p-20">
              <b-card-body>
                <form @submit.prevent="forgotPassSubmit">
                  <h4 class="font-400 text-center mb-15 color-primary">Forgot Password</h4>
                  <div class="font-13 font-300 text-center mb-10">
                    <span>Please enter the email address of your account.</span>
                  </div>
                  <div class="mb-15">
                    <b-form-input type="text" class="form-control" v-model="dataUser.email" name="email" v-validate="'required|email'" placeholder="Email" autocomplete="on"/>
                    <span class="error">{{ errors.first('email') }}</span>
                  </div>
                  <div class="mb-10">
                    <button type="submit" class="btn-primary w-100">Submit</button>
                  </div>
                  <div class="text-center">
                    <a @click="openPage('/')" class="color-primary custom-link font-13 font-400">Back to Login</a>
                  </div>
                </form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { Auth } from '@/api'
import axios from 'axios'

export default {
  name: 'Login',
  data: () => ({
    notificationSystem: {
      options: {
        success: {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        }
      }
    },
    dataUser: {
      email: ''
    }
  }),
  created () {
    console.log('paradigm role', Auth.Session.get().paradigm_role)
    console.log('paradigm id', Auth.Session.get().paradigm_id)
  },
  methods: {
    openPage (event) {
      this.$router.push(event)
    },
    forgotPassSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post('vendor/v1/user/forget_password/', this.dataUser).then(response => {
            // console.log('test', response)
            this.$toast.success('Reset link has been sent to your email!', 'Success', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
            this.$router.push('/')
          }).catch(error => {
            console.log('error', error)
            this.$toast.success("Can't find data!", 'Error', {
              position: 'topCenter',
              icon: 'icon-envelope',
              progressBarColor: 'rgb(0, 255, 184)',
              theme: 'dark',
              backgroundColor: '#565c70',
              messageColor: '#fff'
            })
          })
        } else {
          this.$toast.success('please fill in required fields!', 'Error', {
            position: 'topCenter',
            icon: 'icon-envelope',
            progressBarColor: 'rgb(0, 255, 184)',
            theme: 'dark',
            backgroundColor: '#565c70',
            messageColor: '#fff'
          })
        }
      })
    }
  }
}
</script>
